import { IHttpService } from 'angular';

import { Module } from '../../ts/Module';

import { ServiceLocator } from '../../app/ServiceLocator';
import { IResult } from '../../ts/ServerApi/types/IResponse';

export type FavoriteRepresentation = IResult & {
  contentId: string;
  contentType: string;
  position?: Number;
};

// TODO: we will need to replace this with the Monolith/Kube relative path once configured
// Integration Tests: /content-favorites/favorites
// Local Development: http://localhost:9090/favorites
const FAVORITES_URL = '/content-favorites/favorites';

export class FavoritesResource {

  public static $inject = [
    '$http'
  ];

  constructor(private $http: ng.IHttpService) { }

  public getFavorites(userId: string): ng.IPromise<Array<FavoriteRepresentation>>{
    const requestConfig: ng.IRequestConfig = {
      method: 'GET',
      url: FAVORITES_URL,
      params: {
        userId
      },
    };

    return this.$http(requestConfig).then((response: any)=> {
      return this.mapAll(response);
    });
  }

  public add(favorite: FavoriteRepresentation, userId: string): ng.IPromise<FavoriteRepresentation> {

    const requestConfig: ng.IRequestConfig = {
      method: 'POST',
      data: {
        userId,
        type: favorite.contentType,
        contentId: favorite.contentId
      },
      url: FAVORITES_URL,
    };

    return this.$http(requestConfig).then((response: any)=> {
      return this.mapOne(response);
    });
  }

  public remove(favorite: FavoriteRepresentation, userId: string): ng.IPromise<IResult> {
    const requestConfig: ng.IRequestConfig = {
      method: 'DELETE',
      url: `${FAVORITES_URL}/${favorite.contentType}/${favorite.contentId}`,
      params: {
        userId
      },
    };

    return this.$http(requestConfig).then((response: any)=> {
      return this.mapOne(response);
    });
  }


  private mapAll(response: any): Array<FavoriteRepresentation> {
    const favoriteData = response.data;
    const all: Array<FavoriteRepresentation> = [];
    if(favoriteData){
      for(let item of favoriteData){
        all.push(this.map(item));
      }
    }
    return all;
  }

  private mapOne(response: any): FavoriteRepresentation {
    const favoriteResponse = response.data;
    return this.map(favoriteResponse);
  }

  private map(favoriteResponse: any): FavoriteRepresentation{
    return {
      contentId: favoriteResponse.contentId,
      contentType: favoriteResponse.type,
      position: favoriteResponse.sortPosition,
    };
  }
}

Module.instance().service('FavoritesResource', FavoritesResource);
